import React from 'react'
import { Outlet } from 'react-router-dom'

const Shoppers = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Shoppers